import { AxiosResponse } from 'axios';
import { ReactNode } from 'react';
import GenericExportModal from '~/components/molecules/Shared/GenericExportModal';
import { IExportColumn } from '~/components/molecules/Shared/GenericExportModal/GenericExportModal';
import ReportHeader from '~/components/molecules/Shared/ReportHeader';
import useHeaderWithColumnSelectionExport from './useHeaderWithColumnSelectionExport';

export interface IProps {
  title: string;
  subtitle: string;
  fileName: string;
  isDisabledButton: boolean;
  getExcelExport?: (selectedColumns: string[]) => Promise<AxiosResponse<any>>; // TODO: remover o any
  additionalAction?: ReactNode;
  onClickOpenModal?: () => void;
  onError?: (error: Error) => void;
  exportColumns: IExportColumn[];
}
export default function HeaderWithColumnSelectionExport(props: IProps) {
  const {
    title,
    subtitle,
    fileName = 'relatório.xlsx',
    isDisabledButton,
    getExcelExport,
    additionalAction,
    onClickOpenModal,
    onError,
    exportColumns,
  } = props;

  const { exportState, modalVisible, handleExportClick, handleModalClose, handleOpenModal } =
    useHeaderWithColumnSelectionExport({
      getExcelExport,
      onError,
      fileName,
      onClickOpenModal,
    });

  return (
    <>
      <ReportHeader
        title={title}
        subtitle={subtitle}
        hasExport
        exportState={exportState}
        openModal={handleOpenModal}
        isDisabledButton={isDisabledButton}
        additionalAction={additionalAction}
      />

      <GenericExportModal
        isOpen={modalVisible}
        onCancel={handleModalClose}
        onExport={handleExportClick}
        columns={exportColumns}
      />
    </>
  );
}
